import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type GetAccountUserGroupsQueryVariables = GraphQLTypes.Exact<{
  accountId: GraphQLTypes.Scalars['String']['input'];
}>;

export type GetAccountUserGroupsQueryResult = { __typename?: 'Query' } & {
  accountUserGroups: Array<
    { __typename?: 'AccountUserGroup' } & Pick<
      GraphQLTypes.AccountUserGroup,
      'description' | 'isDefaultRole' | 'name' | 'userGroupId'
    >
  >;
};

export const GetAccountUserGroupsDocument = gql`
  query getAccountUserGroups($accountId: String!) {
    accountUserGroups(accountId: $accountId) {
      description
      isDefaultRole
      name
      userGroupId
    }
  }
`;
